var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676570",
    fillRule: "evenodd",
    d: "M4.983 12h.022a.5.5 0 0 0 .397-.197L9.2 8.005a.498.498 0 1 0-.705-.705l-2.99 2.99V.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5v9.8l-3-3a.498.498 0 1 0-.705.705l3.85 3.85c.094.09.21.14.333.144",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowDown;